export default function ExportIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 512 512"
      preserveAspectRatio="xMidYMid meet"
      focusable="false"
      aria-hidden
      {...props}
    >
      <g
        transform="translate(0 512) scale(0.1 -0.1)"
        fill="currentColor"
        stroke="none"
      >
        <path
          d="M1730 4674 c-30 -8 -93 -33 -140 -55 -83 -40 -93 -49 -461 -418 -367
-367 -377 -378 -418 -461 -74 -153 -71 -67 -71 -1585 0 -1103 3 -1369 14
-1410 28 -107 90 -192 182 -251 107 -68 13 -65 1530 -62 l1369 3 67 32 c94 44
160 109 206 202 35 70 37 81 37 167 0 87 -2 95 -30 136 -107 151 -335 109
-380 -70 l-12 -47 -1277 -3 -1276 -2 0 1175 0 1175 343 0 c373 0 418 5 507 57
68 40 133 112 171 188 l34 70 5 375 5 375 745 0 745 0 5 -460 c5 -503 3 -487
67 -547 103 -98 267 -67 334 65 19 36 20 59 17 550 l-3 512 -32 66 c-41 84
-118 161 -202 202 l-66 32 -980 2 c-828 2 -989 0 -1035 -13z m-20 -774 l0
-270 -277 0 -278 0 270 270 c148 149 273 270 277 270 5 0 8 -121 8 -270z"
        />
        <path
          d="M3590 2931 c-105 -34 -160 -106 -160 -211 0 -74 24 -110 159 -245
l121 -120 -817 -5 -818 -5 -47 -28 c-84 -49 -124 -149 -97 -244 16 -59 78
-124 135 -141 31 -9 238 -12 845 -12 l803 0 -127 -128 c-136 -137 -157 -172
-157 -252 0 -146 153 -250 288 -195 46 19 674 642 703 697 23 45 25 124 4 176
-20 46 -633 664 -687 693 -44 23 -112 32 -148 20z"
        />
      </g>
    </svg>
  );
}
